var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _path6, _path7, _path8, _g, _rect5, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlassIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9883 88.9606L72.3032 94.6112C73.6251 94.7415 74.8015 93.7733 74.9278 92.451L80.334 35.8659L71.0259 25.4289L62.169 15.7106L22.6206 11.6464C21.2982 11.5105 20.1172 12.4754 19.9868 13.7983L12.8354 86.3367C12.7053 87.6558 13.6692 88.8306 14.9883 88.9606Z",
    fill: "#648CFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2058 15.5492L80.4009 35.7768L63.8833 34.1483C61.9628 33.959 60.5594 32.2486 60.7488 30.3281L62.2058 15.5492Z",
    fill: "#2538BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9844 108.65L104.117 101.381C105.434 101.214 106.365 100.008 106.194 98.6905L98.85 42.3241L87.4496 34.2247L76.6492 26.7253L37.1899 31.5794C35.8705 31.7417 34.9343 32.9456 35.1021 34.2643L44.3008 106.572C44.468 107.887 45.6696 108.817 46.9844 108.65Z",
    fill: "#2538BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5844 106.85L101.717 99.5816C103.034 99.414 103.965 98.2079 103.794 96.8907L96.45 40.5243L85.0495 32.4249L74.2491 24.9255L34.7899 29.7796C33.4705 29.9419 32.5343 31.1458 32.7021 32.4645L41.9007 104.772C42.068 106.087 43.2695 107.017 44.5844 106.85Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.249 24.76L96.4954 40.4226L80.0304 42.5172C78.116 42.7607 76.3667 41.4062 76.1231 39.4918L74.249 24.76Z",
    fill: "#A8CCF8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.2568,
    y: 47.2112,
    width: 25.8,
    height: 3.6,
    rx: 1.8,
    transform: "rotate(-7.25 41.2568 47.2112)",
    fill: "#A8CCF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9983,
    y: 60.9009,
    width: 48.6,
    height: 3.6,
    rx: 1.8,
    transform: "rotate(-7.25 42.9983 60.9009)",
    fill: "#A8CCF8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7399,
    y: 74.5906,
    width: 48.6,
    height: 3.6,
    rx: 1.8,
    transform: "rotate(-7.25 44.7399 74.5906)",
    fill: "#A8CCF8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4814,
    y: 88.2802,
    width: 39,
    height: 3.6,
    rx: 1.8,
    transform: "rotate(-7.25 46.4814 88.2802)",
    fill: "#A8CCF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0044 113.774C12.689 111.769 13.2482 109.077 15.2533 107.762L51.6041 83.9148L56.3676 91.1761L20.0168 115.023C18.0117 116.338 15.3199 115.779 14.0044 113.774Z",
    fill: "#648CFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2292 98.643C101.599 95.0194 111.121 79.6222 107.498 64.2524C103.874 48.8826 88.4768 39.3604 73.107 42.9839C57.7372 46.6075 48.215 62.0048 51.8386 77.3746C55.4622 92.7444 70.8594 102.267 86.2292 98.643ZM84.8295 92.7064C96.9204 89.8559 104.411 77.7434 101.561 65.6525C98.7101 53.5615 86.5976 46.0707 74.5067 48.9213C62.4157 51.7719 54.9249 63.8843 57.7755 75.9753C60.626 88.0662 72.7385 95.557 84.8295 92.7064Z",
    fill: "#648CFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6873_126881",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 83,
    width: 44,
    height: 33
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0041 113.774C12.6887 111.769 13.2478 109.077 15.2529 107.762L51.6037 83.9148L56.3672 91.1761L20.0165 115.023C18.0113 116.338 15.3195 115.779 14.0041 113.774Z",
    fill: "#648CFE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6873_126881)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.5754,
    y: 110.311,
    width: 47.7682,
    height: 8.90134,
    transform: "rotate(-33.2658 11.5754 110.311)",
    fill: "url(#paint0_linear_6873_126881)"
  })))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1459,
    y: 83.371,
    width: 1.77909,
    height: 8.76931,
    rx: 0.889544,
    transform: "rotate(-33.2658 52.1459 83.371)",
    fill: "#2538BF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.8751,
    y: 84.3641,
    width: 1.77909,
    height: 8.76931,
    rx: 0.889544,
    transform: "rotate(-33.2658 50.8751 84.3641)",
    fill: "#2538BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6873_126881",
    x1: 23.5175,
    y1: 118.656,
    x2: 24.7829,
    y2: 108.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2538BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#2538BF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassIllustration);
export default __webpack_public_path__ + "static/media/magnifying-glass-illustration.709bfb1989bb1a3d9a4b71c3c840ea58.svg";
export { ForwardRef as ReactComponent };